// @ts-expect-error pure js
import useProfileBailleurs from "../../../hooks/use-profile-bailleurs.js";
import useProfileFilter from "../../../hooks/use-profile-filter";
import {
  MultiSelectDropdownStandalone,
  type MultiSelectOption,
} from "../MultiSelectDropdown";
import type { ProfileBailleur } from "../../Profile/types";
import styles from "./ProfileFilterSelect.module.css";

export default function ProfileFilterSelect() {
  const { profileBailleurs } = useProfileBailleurs() as {
    profileBailleurs: ProfileBailleur[];
  };
  const { selectedProfileIds, setSelectedProfileIds } = useProfileFilter();

  if (!profileBailleurs || profileBailleurs.length <= 1) {
    return null;
  }

  const options: MultiSelectOption[] = profileBailleurs.map((p) => ({
    value: String(p.id),
    label: p.nom_profile,
  }));
  const value = options.filter((o) =>
    selectedProfileIds.includes(Number(o.value)),
  );

  return (
    <div className={styles.wrapper}>
      <MultiSelectDropdownStandalone
        label="Profils"
        hiddenLabel
        options={options}
        value={value}
        onChange={(selected) =>
          setSelectedProfileIds(selected.map((o) => Number(o.value)))
        }
        placeholder="Tous les profils"
      />
    </div>
  );
}
